import { render, staticRenderFns } from "./settingThirdPlatform.vue?vue&type=template&id=cc52e666&scoped=true"
import script from "./settingThirdPlatform.vue?vue&type=script&lang=js"
export * from "./settingThirdPlatform.vue?vue&type=script&lang=js"
import style0 from "./settingThirdPlatform.vue?vue&type=style&index=0&id=cc52e666&prod&lang=less&scoped=true"
import style1 from "./settingThirdPlatform.vue?vue&type=style&index=1&id=cc52e666&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc52e666",
  null
  
)

export default component.exports